export default "__VITE_ASSET__c3cb3a62__"